export enum ProviderType {
  No = 0,
  Cattle = 1,
  Sheep = 2,
  Both = 3,
}

export enum ModeType {
  Cattle = "C",
  Sheep = "S",
}

export const Sites = {
  Perth: "PE",
  Ellesmere: "EL",
  Yetminster: "YE",
  Lurgan: "LU",
  Dungannon: "LD",
  BOA: "BA",
  Kingswinford: "KI",
};

export const SiteNames = {
  Yetminster: 'Yetminster',
  Kingswinford: 'Kingswinford',
  BOA: 'Bridge of Allan'
}

export const PAGE_DEFAULT = {
  pageSize: 10,
  pageSizeMax: 999,
  firstPage: "1",
};

export const PATH_MODE_VARIABLE = "mode";

export const DATE_TIME_FORMAT = "DD/MM/YYYY";
export const DATE_TIME_FORMAT_CALENDAR = "MM/DD/YYYY";

export const UK_TIMEZONE = "Europe/London";

export const FILTER_ALL = '[ "All" ]';

export enum NotificationTypes {
  UnreadAlert = "UnreadAlert",
  AlertToDocumentHub = "AlertToDocumentHub",
  ToggleMaintenanceStatus = "ToggleMaintenanceStatus",
  AgreementFormStatusChange = "AgreementFormStatusChange",
  FarmGroupStatusChange = "FarmGroupStatusChange",
  ResetPasswordNotification = "ResetPasswordNotification",
  PortalReport = "PortalReport",
  PgaFormReset = "PgaFormReset",
  LoginSuccessEvent = "LoginSuccessEvent",
}

export const NOT_AVAILABLE = "N/A";
export const AWAITING_DATA = "Awaiting Data";
export const CMS_USER = 'CMSUser';

export enum UserRole {
  Farmer = "farmer",
  Admin = "admin",
}

export const NO_DATA = "Sorry, we couldn't find any data that matched your criteria.";

export const countriesPGAForm = [
  {
    label: "England",
    value: 1,
  },
  {
    label: "Scotland",
    value: 2,
  },
  {
    label: "Wales",
    value: 3,
  },
  {
    label: "Northern Ireland",
    value: 4,
  },
];

export const NUMBER_OF_ANIMALS_AFFECTED_HEADING = "Number of Animals Affected";
export const NUMBER_OF_ANIMALS_AFFECTED_TEXT =
  "If animal has multiple conditions, number of affected may not equal number of animals.";

export const POTENTIAL_IMPACT_CONDITION_ITEM = "PotentialImpactConditionItem"
export const POTENTIAL_IMPACT_TEXT: Map<string, string> = new Map([
  [
    ModeType.Cattle,
    "Potential impact is calculated based on the average potential impact per head for Liver Fluke and Pneumonia as quoted in AHDB's Abattoir Post-mortem Conditions Guide.",
  ],
  [
    ModeType.Sheep,
    "Potential impact is calculated based on the average potential impact per head for Liver Fluke as quoted in AHDB's Abattoir Post-mortem Conditions Guide.",
  ],
  [
    POTENTIAL_IMPACT_CONDITION_ITEM,
    "Potential impact is calculated based on the average potential impact per head as quoted in AHDB's Abattoir Post-mortem Conditions Guide"
  ]
]);

export const ALLOWED_POST_MORTEM_SITES: Map<string, string[]> = new Map([
  [ModeType.Sheep, [Sites.BOA, Sites.Kingswinford, Sites.Yetminster]],
]);

export enum ReportType {
  PostMortem = 3,
}

export enum CMSUserPermission {
  AccessPortal_ViewAll = '9c',
  // AccessPortal_ExceptBenchmarkingGroups = '9d',
  // AccessPortal_ExceptMyDocuments = '9e',
  AccessPortal_ExceptMyDocuments_BenchmarkingGroups = '9e',
  AccessPortal_CreateDeleteVATReport = '9f',
}

export const DateApplyNewGradeForCattleBOA = new Date(2025, 5, 30);

export const S_GRADE_SHEEP_SITES = [SiteNames.BOA, SiteNames.Kingswinford, SiteNames.Yetminster];
